var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_9333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3 13.3868C25.3933 8.78683 21.3533 5.3335 16.5 5.3335C12.6467 5.3335 9.3 7.52016 7.63333 10.7202C3.62 11.1468 0.5 14.5468 0.5 18.6668C0.5 23.0802 4.08667 26.6668 8.5 26.6668H25.8333C29.5133 26.6668 32.5 23.6802 32.5 20.0002C32.5 16.4802 29.7667 13.6268 26.3 13.3868ZM19.1667 17.3335V22.6668H13.8333V17.3335H9.83333L16.0333 11.1335C16.3 10.8668 16.7133 10.8668 16.98 11.1335L23.1667 17.3335H19.1667Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_9333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file_upload_icon.c531e66ba92170fa705cfc254f35ff64.svg";
export { ForwardRef as ReactComponent };